<template>
  <div>
    <AlerteEspaceMembre />
    <div class="text-center my-2 my-sm-6 my-md-12">
      <LinkLogo class="mx-auto" />
    </div>
    <v-sheet class="d-flex justify-space-between mx-auto mb-2 align-center" max-width="800">
      <ChangeLocale />
      <div>
        <router-link
          :to="{
            name: 'FormulaireAdhesionPersonneToucheeParLeDiabete',
            query: this.$route.query
          }"
          v-show="!personneVivantAvecLeDiabete"
          class="mr-2"
          >{{ $t("formulaireAdhesion.personneVivantAvecLeDiabete.lien") }}</router-link
        >
        <router-link
          :to="{
            name: 'FormulaireAdhesionProfessionnelDeLaSante',
            query: this.$route.query
          }"
          v-show="!professionnelDeLaSante"
          class="mr-2"
          >{{ $t("formulaireAdhesion.professionnelDeLaSante.lien") }}</router-link
        >
      </div>
    </v-sheet>
    <v-sheet max-width="800" class="py-4 py-md-8 py-lg-12 px-2 px-md-6 px-lg-12 mx-auto mb-6" id="bordered-sheet">
      <v-sheet max-width="500" class="mx-auto">
        <h1 class="display-2">{{ $t(titleKey) }}</h1>

        <v-divider class="mt-2 mb-4"></v-divider>
        <Account class="mb-6" />
        <v-form ref="formulaireAdhesion" :disabled="loading">
          <p class="font-weight-bold">
            {{ $t("formulaireAdhesion.typeAdhesion") }}
          </p>
          <!-- :rules="required" -->
          <v-radio-group v-model="typeAdhesion">
            <v-radio v-for="type in adhesionsToShow" :key="type.identifiant" :value="type">
              <template v-slot:label>{{ type[$i18n.locale] }}</template>
            </v-radio>
          </v-radio-group>

          <p class="font-weight-bold">
            {{ $t("formulaireAdhesion.versionPleinSoleil") }}
          </p>
          <v-radio-group v-model="version" :rules="required">
            <v-radio v-for="v in catalogues.versionsRevue" :key="v.id" :value="v.id">
              <template v-slot:label>{{ v[$i18n.locale] }}</template>
            </v-radio>
          </v-radio-group>

          <template v-if="typeAdhesion && typeAdhesion.activerLeCodePromo">
            <p class="font-weight-bold">
              {{ $t("formulaireAdhesion.codePromo") }}
            </p>
            <v-text-field v-model="codePromo" outlined hide-details="auto">
              <template v-slot:label>{{ $t("formulaireAdhesion.codePromoLabel") }}</template>
              <template v-slot:append>
                <v-progress-circular v-if="loading" color="primary" indeterminate></v-progress-circular>
                <v-icon v-else :color="codePromoValide ? 'green' : 'red'">
                  {{ codePromoValide ? "mdi-check" : "mdi-close" }}
                </v-icon>
              </template>
            </v-text-field>
            <span v-if="codePromoValide === false" style="color: red">{{ $t("rules.erreurCodePromo") }}</span>
            <div class="text-center mt-2">
              <v-btn color="primary" large @click="checkCodePromo" :disabled="loading" :loading="loading">
                {{ $t("formulaireAdhesion.boutonCheckCodePromo") }}
              </v-btn>
            </div>
          </template>

          <template v-if="professionnelDeLaSante">
            <p class="font-weight-bold">
              {{ $t("formulaireAdhesion.professionnelDeLaSante.agreementSharing") }}
            </p>
            <v-radio-group v-model="agreementSharing" :rules="required">
              <v-radio v-for="value in ouiNon" :key="value.id" :value="value.id">
                <template v-slot:label>{{ value[$i18n.locale] }}</template>
              </v-radio>
            </v-radio-group>
          </template>

          <h2 class="mb-2 mt-6">
            {{ $t("formulaireAdhesion.informationsPersonnelles") }}
          </h2>

          <LoadingComponent :loading="loadingCatalogues">
            <v-radio-group row v-model="civilite" :rules="required">
              <v-radio v-for="civilite in catalogues.civilites" :key="civilite.id" :value="civilite.id">
                <template v-slot:label>{{ civilite[$i18n.locale] }}</template>
              </v-radio>
            </v-radio-group>
          </LoadingComponent>

          <v-text-field v-model="courriel" outlined :rules="requiredEmail" :disabled="authMethod === 'TokenExtranetX'">
            <template v-slot:label>{{ $t("infosPersonnelles.courriel") }} *</template>
          </v-text-field>
          <v-text-field v-model="prenom" outlined :rules="required">
            <template v-slot:label>{{ $t("infosPersonnelles.prenom") }} *</template>
          </v-text-field>
          <v-text-field v-model="nom" outlined :rules="required">
            <template v-slot:label>{{ $t("infosPersonnelles.nom") }} *</template>
          </v-text-field>
          <v-select v-model="anneeNaissance" outlined :items="anneesDeNaissance">
            <template v-slot:label>{{ $t("infosPersonnelles.anneeNaissance") }}</template>
          </v-select>
          <template v-if="professionnelDeLaSante">
            <LoadingComponent :loading="loadingCatalogues">
              <v-autocomplete
                :items="catalogues.professions"
                v-model="profession"
                outlined
                :item-text="$i18n.locale"
                item-value="id"
                :rules="required"
              >
                <template v-slot:label>{{ $t("formulaireAdhesion.professionnelDeLaSante.profession") }} *</template>
              </v-autocomplete>
            </LoadingComponent>
            <v-text-field v-model="license" outlined :rules="required">
              <template v-slot:label>{{ $t("formulaireAdhesion.professionnelDeLaSante.license") }} *</template>
            </v-text-field>
          </template>

          <h2 class="mb-2">{{ $t("formulaireAdhesion.adresse") }}</h2>
          <v-text-field v-model="adresse" outlined :rules="required" id="adresse-field">
            <template v-slot:label>{{ $t("adresse.adresse") }} *</template>
          </v-text-field>
          <v-text-field v-model="ville" outlined :rules="required">
            <template v-slot:label>{{ $t("adresse.ville") }} *</template>
          </v-text-field>
          <v-text-field v-model="codePostal" outlined v-facade="'A#A #A#'" :rules="codePostalRules">
            <template v-slot:label>{{ $t("adresse.codePostal") }} *</template>
          </v-text-field>

          <LoadingComponent :loading="loadingCatalogues">
            <v-autocomplete :items="catalogues.provinces" v-model="province" outlined :item-text="$i18n.locale" item-value="id" :rules="required">
              <template v-slot:label>{{ $t("adresse.province") }} *</template>
            </v-autocomplete>
          </LoadingComponent>
          <v-text-field v-model="telephone" outlined v-facade="'(###) ### ####'" :rules="phoneRules">
            <template v-slot:label>{{ $t("adresse.telephone") }} *</template>
          </v-text-field>
          <v-text-field v-model="telephoneAuTravail" outlined v-facade="'(###) ### ####'" :rules="optionalPhoneRules">
            <template v-slot:label>{{ $t("adresse.telephoneAuTravail") }}</template>
          </v-text-field>

          <v-checkbox v-model="desireFaireUnDon">
            <template v-slot:label
              ><span class="font-weight-bold">{{ $t("formulaireAdhesion.desireFaireUnDon") }}</span></template
            >
          </v-checkbox>
          <SelectionMontant v-if="desireFaireUnDon" :montants="[25, 50, 75]" v-model="montant" :disabled="loading" />

          <h2 class="mb-2">{{ $t("formulaireAdhesion.source") }}</h2>

          <LoadingComponent :loading="loadingCatalogues">
            <div v-for="(sourceItem, index) in catalogues.adhesionSources" :key="sourceItem.id">
              <v-checkbox
                :value="sourceItem.id"
                v-model="source" class="mt-0"
                :rules="requiredMultiple"
                :hide-details="index !== catalogues.adhesionSources.length - 1" 
              >
                <template v-slot:label>{{ sourceItem[$i18n.locale] }}</template>
              </v-checkbox>
            </div>
          </LoadingComponent>
        </v-form>

        <v-btn block color="primary" large @click="payNow" :disabled="loading" :loading="loading">{{
          $t("formulaireAdhesion.boutonPaiement")
        }}</v-btn>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>
import LinkLogo from "@/components/common/LinkLogo"
import Account from "@/components/common/Account.vue"
import SelectionMontant from "@/components/common/SelectionMontant.vue"
import ChangeLocale from "@/components/common/ChangeLocale"
import LoadingComponent from "@/components/common/LoadingComponent"
import AlerteEspaceMembre from "@/components/common/AlerteEspaceMembre"

import CataloguesLoader from "@/mixins/CataloguesLoader"
import Auth from "@/mixins/Auth"
import PosteCanada from "@/mixins/PosteCanada"
import InfosPersonnellesModel from "@/mixins/InfosPersonnellesModel"
import Rules from "@/mixins/Rules"
import PaysafeModale from "@/mixins/PaysafeModale"
import { Api } from "@/plugins/api"
import { mapGetters } from "vuex"

export default {
  mixins: [CataloguesLoader, PosteCanada, InfosPersonnellesModel, Rules, PaysafeModale, Auth],
  data() {
    return {
      cataloguesToLoad: ["civilites", "provinces", "professions", "versionsRevue", "adhesionSources"],
      montant: 25,
      typeAdhesion: undefined,
      categoriesMembre: [],
      loadingCategoriesMembre: false,
      version: undefined,
      desireFaireUnDon: false,
      profession: undefined,
      agreementSharing: undefined,
      license: "",
      codePromo: undefined,
      codePromoValide: undefined,
      source: [],
      loading: false,
      ouiNon: [
        { id: "oui", fr: "Oui", en: "Yes" },
        { id: "non", fr: "Non", en: "No" }
      ]
    }
  },
  methods: {
    async payNow() {
      if (!this.$refs.formulaireAdhesion.validate()) {
        return
      }
      this.loading = true
      const montantTotal =
        this.montantAdhesion +
        (this.desireFaireUnDon ? this.montant : 0) -
        (this.typeAdhesion.activerLeCodePromo === true && (await this.checkCodePromo()) === true ? this.typeAdhesion.valeurCodePromo : 0)
      this.showPaysafeModale(montantTotal, `${this.prenom} ${this.nom}`)
    },

    onSuccessPaysafe(token) {
      this.loading = true
      let payload = {
        nom: this.nom,
        prenom: this.prenom,
        province: this.province,
        adresse: this.adresse,
        telephone: this.telephone,
        telephoneAuTravail: this.telephoneAuTravail,
        civilite: this.civilite,
        codePostal: this.codePostal,
        ville: this.ville,
        montant: this.montant,
        courriel: this.courriel,
        typeAdhesion: this.typeAdhesion.identifiant,
        desireFaireUnDon: this.desireFaireUnDon,
        profession: this.profession,
        agreementSharing: this.agreementSharing,
        license: this.license,
        version: this.version,
        typeDeDedicace: this.typeDeDedicace,
        paymentToken: token,
        langue: this.$i18n.locale,
        agreementSharing: this.agreementSharing === "oui",
        anneeNaissance: this.anneeNaissance,
        codePromotionnel: this.codePromo,
        source: this.source
      }

      Api.post("/adhesions", payload)
        .then((res) => {
          const paiementReussi = res.data.paiementReussi
          if (paiementReussi) {
            this.$router.push({ name: "RemerciementAdhesion", query: this.$route.query, params: { avecDon: res.data.avecDon } })
          } else {
            this.$router.push({ name: "ErreurPaiement", query: this.$route.query })
          }
        })
        .catch(() => {
          this.$router.push({ name: "ErreurPaiement", query: this.$route.query })
        })
        .finally(() => {
          this.loading = false
        })
    },
    onCloseBeforePayment() {
      this.loading = false
    },
    loadTypesAdhesion() {
      this.loadingCategoriesMembre = true
      Api.get("/categories-membres")
        .then((res) => {
          this.categoriesMembre = res.data
        })
        .finally(() => (this.loadingCategoriesMembre = false))
    },
    async checkCodePromo() {
      this.loading = true
      let response = await Api.get("categories-membres/" + this.typeAdhesion.identifiant + "/code-promo/" + this.codePromo + "/check")
      this.codePromoValide = response.data
      this.loading = false
      return response.data
    }
  },
  computed: {
    ...mapGetters(["catalogues", "authMethod"]),
    professionnelDeLaSante() {
      return this.$route.name === "FormulaireAdhesionProfessionnelDeLaSante"
    },
    personneVivantAvecLeDiabete() {
      return this.$route.name === "FormulaireAdhesionPersonneToucheeParLeDiabete"
    },
    titleKey() {
      if (this.professionnelDeLaSante) {
        return "formulaireAdhesion.professionnelDeLaSante.titre"
      } else if (this.personneVivantAvecLeDiabete) {
        return "formulaireAdhesion.personneVivantAvecLeDiabete.titre"
      }
      return "formulaireDon.donEnLigne"
    },
    adhesionsToShow() {
      if (this.loadingCategoriesMembre) {
        return []
      }

      if (this.professionnelDeLaSante) {
        return this.categoriesMembre.filter((t) => t.categorie.includes("PROFESSIONNEL"))
      } else if (this.personneVivantAvecLeDiabete) {
        return this.categoriesMembre.filter((t) => t.categorie.includes("REGULIER"))
      }
      return []
    },
    montantAdhesion() {
      if (this.loadingCatalogues) {
        return 0
      }

      const adhesion = this.categoriesMembre.find((c) => c.identifiant == this.typeAdhesion.identifiant)

      return adhesion?.prix ?? 0
    },
    typeDeDedicace() {
      if (this.professionnelDeLaSante) {
        return "ProfessionnelSante"
      } else {
        return "Regulier"
      }
    }
  },
  components: {
    LinkLogo,
    Account,
    SelectionMontant,
    ChangeLocale,
    LoadingComponent,
    AlerteEspaceMembre
  },
  async mounted() {
    this.$i18n.locale = this.$route.query.lang || "fr"
    this.loginWithToken()
    await this.loadTypesAdhesion()
  }
}
</script>
